import {
  Button,
  Input,
  FormControl,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  Alert,
  Snackbar,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./ManageAccess.css";
import { useDispatch, useSelector } from "react-redux";
import { addAdminUser } from "../../../function-components/Redux/AdminUserSlice";

const ManageAccess = () => {
  const trackId = 1;
  const [selectedroles, setSelectedRoles] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [userName, setUsername] = useState("");
  const { isLoaded, isDataSentSuccess, isDataSentFailure } =
    useSelector((state) => state.adminUser) ?? false;
  const [isUser, setIsUser] = useState(false);
  const [severity, setSeverity] = useState(null);
  const [statusMessage, setStatusMessage] = useState();

  const dispatch = useDispatch();
  const definedRoles = ["Requestor", "TH"];
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRoles([]);
    } else {
      setSelectedRoles(definedRoles);
    }
    setSelectAll(!selectAll);
  };
  const submitFormHandler = (e) => {
    e.preventDefault();
  };
  const addUserHandler = () => {
    if (userName !== "" && selectedroles.length > 0) {
      const rolesJson = definedRoles.map((role) => ({
        role: role.toLowerCase(),
        status: selectedroles.includes(role), // true if selected, false otherwise
      }));

      const payload = {
        enterpriseID: userName,
        assigned_tracks: [{ id: trackId, roles: rolesJson }],
      };

      dispatch(addAdminUser(payload));
      setIsUser(true);
      setUsername("");
      setSelectedRoles([]);
      setSelectAll(false);
    } else {
      setIsUser(true);
      setStatusMessage("Please select Required Fields!");
      setSeverity("warning");
    }
  };

  useEffect(() => {
    if (isUser) {
      if (isLoaded) {
        setSeverity("warning");
        setStatusMessage("Adding User... Please wait.");
      } else if (isDataSentSuccess) {
        setSeverity("success");
        setStatusMessage(isDataSentSuccess);
      } else {
        setSeverity("error");
        setStatusMessage("Error in Adding User.");
      }
    }
  }, [isLoaded, isDataSentSuccess, isDataSentFailure]);
  return (
    <div id="manage-access">
      <div className="addUserLable">Add User</div>
      <div>
        {isUser && severity && (
          <Snackbar
            open={isUser}
            onClose={() => setIsUser(false)}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }} // Positioning
            className="custom-snackbar"
          >
            <Alert severity={severity} onClose={() => setIsUser(false)}>
              {statusMessage}
            </Alert>
          </Snackbar>
        )}
      </div>
      <div className="user-container">
        <FormControl
          fullWidth
          onSubmit={submitFormHandler}
          className="form-container"
        >
          <div className="username element">
            <span className="lable">
              <span className="required-field">*</span>Enterprise ID:
            </span>
            <Input
              id="enterpriseid"
              className="right-element"
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              value={userName}
              autoComplete="off"
              placeholder="Enter Enterprise iD"
              required
            />
          </div>
          <span className="user-instruction">
            (Please add Enterprise ID in <strong>abc.xyz</strong> format.)
          </span>
          <FormControl className="selectionSelection element">
            <span className="lable">
              <span className="required-field">*</span>Select Role:
            </span>
            <Select
              multiple
              id="select-section right"
              className="select-dropdown right-element"
              value={selectedroles || []}
              onChange={(e) => {
                const value = e.target.value;
                if (value.includes("selectAll")) {
                  if (selectAll) {
                    setSelectedRoles([]);
                    setSelectAll(false);
                  } else {
                    setSelectedRoles(definedRoles);
                    setSelectAll(true);
                  }
                } else {
                  setSelectedRoles(value);
                }
              }}
              renderValue={(selected) => selected.join(", ")}
            >
              <MenuItem value="selectAll">
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
                <ListItemText primary="Select All" />
              </MenuItem>
              {definedRoles.map((option) => (
                <MenuItem key={option} value={option}>
                  <Checkbox checked={selectedroles.indexOf(option) > -1} />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="form-submit">
            <Button
              className="submit-btn"
              type="submit"
              variant="contained"
              onClick={addUserHandler}
            >
              Add
            </Button>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default ManageAccess;
